import { Component, OnInit } from '@angular/core';
/* tslint:disable:component-selector */

@Component({
  selector: 'input[ccInput]',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
